export const SERVICE_AREAS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'highway',
    label: 'Autopista',
  },
  {
    field: 'route',
    label: 'Recorrido',
  },
  {
    field: 'km',
    label: 'Km.',
    classObj: ['query__header--align-right'],
  },
];
